import { defineComponent as _defineComponent } from 'vue'
import useDeviceManager from '../../../hooks/useDeviceManager';
import SvgIcon from '../../common/base/SvgIcon.vue';
import SpeakerPhoneIcon from '../../common/icons/SpeakerPhoneIcon.vue';
import EarpieceIcon from '../../common/icons/EarpieceIcon.vue';
import { TUIAudioRoute } from '@tencentcloud/tuiroom-engine-js';
import '../../../directives/vTap';
import { computed, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchAudioRoute',
  setup(__props) {

const { deviceManager } = useDeviceManager();
const currentAudioRoute = ref<TUIAudioRoute>(
  TUIAudioRoute.kAudioRouteSpeakerphone
);

const icon = computed(() =>
  currentAudioRoute.value === TUIAudioRoute.kAudioRouteSpeakerphone
    ? SpeakerPhoneIcon
    : EarpieceIcon
);

async function handleSwitchAudioRoute() {
  const audioRoute =
    currentAudioRoute.value === TUIAudioRoute.kAudioRouteSpeakerphone
      ? TUIAudioRoute.kAudioRouteEarpiece
      : TUIAudioRoute.kAudioRouteSpeakerphone;
  await deviceManager.instance?.setAudioRoute({
    route: audioRoute,
  });
  currentAudioRoute.value = audioRoute;
}

return { __sfc: true,deviceManager, currentAudioRoute, icon, handleSwitchAudioRoute, SvgIcon }
}

})